var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step w-80 center"},[_c('ThreeSankey',{staticClass:"mv5",style:(("height: " + (_vm.windowHeight * 0.9) + "px;")),attrs:{"fileString":"policeDisposal","containerHeight":_vm.windowHeight * .9}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }